import { REDUX_DOMAIN_LIST_SECTION_KEY } from '../../../redux/constants/key'

export const EXERCISES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  CREATED: 'created',
  DATA: 'data',
  TYPE_TO_IDS: 'typeToIds',
  BY_QUERY: [REDUX_DOMAIN_LIST_SECTION_KEY.BY_QUERY],
  MUSCLE_TO_IDS: 'muscleToIds'
}
